<template>
<nav id="nav-central" class="navbar fixed-top navbar-expand-lg navbar-dark" v-bind:class="[themeClass, {'unverified-nav': !verifiedAccount}]">
    <div class="navbar-wrap">
        <a class="mr-3" :href="navBarLink">
            <div class="brand-logo-box" v-if="autobahn">
                <img :src="logo" alt="" height="30">
            </div>
            <div class="brand-logo" v-else>
                <img :src="logo" height="60">
            </div>
        </a>
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapsed"
            aria-controls="navbarCollapsed"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="handleToggleNavbar"
        >
            <i class="fa" :class="menuIcon"></i>
        </button>
    </div>
    <!--
        Temporarily commented
        Not sure this element was used or not
        but this element make space on the navbar
    -->
    <!-- <div id="left-nav" class="navbar d-none d-lg-flex mx-auto">
        <ul class="navbar-nav">
            <slot name="left-items">
            </slot>
        </ul>
    </div> -->
    <div id="navbarCollapsed" class="navbar-collapse collapse ml-auto">
        <ul class="navbar-nav">
            <slot name="nav-items">
            </slot>
        </ul>
    </div>
    <noscript>
        <div class="javascript-required mt-5">
            <img class="mb-3" src="/assets/images/cogs.svg">
            <h3>We have a small problem</h3>
            <p>Javascript appears to be disabled, please enable javascript to use Autobahn</p>
        </div>
    </noscript>
</nav>
</template>

<script>
import { getBrandingVar, getBranding } from '~/assets/js/utils/whitelabeling.js';
import '~/scss/component/_navbar.scss';

export default {
    name: 'navbar',
    data() {
        return {
            menuIcon: 'fa-bars',
        };
    },
    props: {
        alterClass: String,
        blackLogo: String,
        onLanding: {
            type: Boolean,
            default: true,
        },
        verifiedAccount: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        wrapClass() {
            let htmlClass;
            if (this.collapse) {
                htmlClass = 'navbar-wrap collapsed';
            } else {
                htmlClass = 'navbar-wrap';
            }
            return htmlClass;
        },
        themeClass() {
            if (this.alterClass) {
                return this.alterClass;
            }
            return getBrandingVar('css_class_navbar');
        },
        navText() {
            return getBrandingVar('navtext');
        },
        navBarLink() {
            return this.onLanding ? '/' : '/home';
        },
        logo() {
            if (this.getBranding() === 'xl') {
                return this.getBrandingVar('app_logo');
            }
            if (this.blackLogo === 'true') {
                return this.getBrandingVar('app_logo');
            }
            return this.getBrandingVar('app_logo_white');
        },
        autobahn() {
            return this.getBranding() === 'autobahn';
        },
    },
    methods: {
        handleToggleNavbar() {
            let icon;
            const target = document.getElementById('navbarCollapsed');
            if (target.classList.value.includes('show')) {
                icon = 'fa-bars';
            } else {
                icon = 'fa-times';
            }
            this.menuIcon = icon;
        },
    },
    mounted() {
        const self = this;
        document.addEventListener('mousedown', (e) => {
            const navbar = document.getElementById('nav-central');
            const collapseMenu = document.getElementById('navbarCollapsed');
            const isNavbar = navbar.contains(e.target);
            if (!isNavbar) {
                collapseMenu.classList.remove('show');
                self.menuIcon = 'fa-bars';
            }
        });
    },
};
</script>

<style lang="scss" scoped>
#nav-central {
    height: 80px;
    margin-bottom: 1rem;

    .navbar-toggler {
        border: none;
        outline: none;
    }
}

.navbar {
    padding: 0.5rem 1.5rem !important;

    &.navbar-autobahn .navbar-collapse {
        background: inherit;
        padding: 0;
    }
}

.unverified-nav {
    z-index: 1041;
}

@media screen and (max-width: 992px) {
    .navbar-collapse {
        position: absolute;
        width: 250px;
        top: 80px;

        .nav-item {
            width:100% !important;
            max-width:100% !important;

            a.btn-topbar {
                max-width: 100% !important;
                margin: 0 .75rem 0.5rem .75rem !important;
            }
        }
    }
}
</style>
